import { type PopupType } from '@/types';

import { NewFeatureBadge } from '@/shared/ui/new-feature-badge/NewFeatureBadge';

export function NavigationIcon({ popup }: { popup: PopupType }) {
  if (!popup.icon) {
    return null;
  }
  if (!popup.releaseDate) {
    return popup.icon;
  }

  return <NewFeatureBadge releaseDate={popup.releaseDate}>{popup.icon}</NewFeatureBadge>;
}
